import { render, staticRenderFns } from "./PreliquidationApproval.vue?vue&type=template&id=51447062"
import script from "./PreliquidationApproval.vue?vue&type=script&lang=js"
export * from "./PreliquidationApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports